import styled from "styled-components";

export const Wrapper = styled.div``;
export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  .xodim {
    display: flex;
    gap: 20px;
  }
  .title {
    padding-bottom: 18px;
    font-family: Inter;
    font-size: 16px;
    font-weight: 500;
    line-height: 16px;
    color: #343c6a;
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .num {
    font-family: Inter;
    font-size: 24px;
    font-weight: 500;
    line-height: 24px;
    color: #6610f2;
  }
`;

export const CardWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 20px;
`;
